// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 882) return "static/chunks/882.58c809ab9d65b818.js";
	if (chunkId === 85) return "static/chunks/85.e61d54e090f4d155.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"212":"bd904a5c","367":"b536a0f1"}[chunkId] || chunkId) + "-" + {"16":"3abd28ab5de16dfd","63":"0817d435ea0c91f4","212":"616a86a498ab711f","277":"7352067a2b0b2817","367":"095e74e1f4680314","874":"12b6f9a7d1b171be"}[chunkId] + ".js";
};